<div
  class="search-menu-actions"
  [ngClass]="{'active': searchContainer.toggleActionMenu && !disabled,
              'tooltip1':  !selectedCount && actionMenuOperations.length}"
  matTooltip="{{'TRANS__VALIDATION__NO_SELECTED_OBJECT' | translate}}"
  [matTooltipDisabled]="!disabled"
>
  <button
    class="search-menu-actions__button"
    (click)="toggleSearchActionMenu()"
    [disabled]="disabled"
    [matMenuTriggerFor]="searchMenu"
    [matMenuTriggerRestoreFocus]="false"
  >
    <span class="common-operation-menu-styling__button-text common-operation-menu-styling__text1">
      {{ 'TRANS__SEARCH__ACTION_MENU__SECTION_TITLE__PROCESS_SELECTION' | translate }}
    </span>

    <span class="common-operation-menu-styling__button-text common-operation-menu-styling__text2">
      {{ 'TRANS__SEARCH__TREAT' | translate }}
    </span>

    @if (actionMenuOperations.length) {
      <span class="common-operation-menu-styling__button-count">
        ({{selectedCount}})
      </span>
    }

    <mat-icon>
      {{searchContainer.toggleActionMenu ? 'expand_less' : 'expand_more'}}
    </mat-icon>
  </button>

  <mat-menu
    #searchMenu="matMenu"
    class="common-operation-menu-styling__menu removePaddingInMatMenu"
    (closed)="searchContainer.toggleActionMenu = false;"
    [overlapTrigger]="false"
  >
    <mat-accordion displayMode="flat">
      @for (operation of actionMenuOperations; track $index) {
        <mat-expansion-panel
          class="no-active-blue-color"
          #currentOperationPanel
          [expanded]="actionMenuOperations.length === 1"
          [class.is-expanded]="currentOperationPanel.expanded || actionMenuOperations.length === 1"
          [class.is-collapsed]="!currentOperationPanel.expanded"
        >
          <mat-expansion-panel-header
            (click)="$event.stopPropagation()"
            (keydown)="null"
            [collapsedHeight]="'40px'"
            [expandedHeight]="'40px'"
          >
            <mat-panel-title [ngClass]="{'bold': currentOperationPanel.expanded}">
              {{ operation.menu_title | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-action-list>
            @for (subOperation of operation.sub_operations; track subOperation) {
              @if (canShowOperation(subOperation)) {
                <button mat-list-item
                        class="common-operation-menu-styling__sub-operation-button"
                        (click)="executeOperation(subOperation, operation)"
                >
                  @if (subOperation.menu_icon) {
                    @if (!subOperation.menu_icon.startsWith('icon-')) {
                      <mat-icon matListItemIcon>
                        {{subOperation.menu_icon}}
                      </mat-icon>
                    }
                    @else {
                      <i
                        matListItemIcon
                        class="{{subOperation.menu_icon}}"
                      ></i>
                    }
                  }

                  <span [attr.title]="subOperation.menu_title | translate">
                    {{ subOperation.menu_title | translate }}
                  </span>
                </button>
              }
            }
          </mat-action-list>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </mat-menu>
</div>
